export default __webpack_public_path__ + "static/media/users_6.614ca2ce.png";